import { Bar } from 'react-chartjs-2';
import { round, baseBarOptions, CHART_COLORS } from '../../../config/chart-config';

const CaloriesChart = ({ labels, values }) => {
    if (!values?.length) return null;

    const data = {
        labels,
        datasets: [
            {
                label: 'Kalorier',
                data: values.map(round),
                backgroundColor: CHART_COLORS.blue
            }
        ]
    };

    const options = {
        ...baseBarOptions,
        plugins: {
            legend: { display: false }
        },
        scales: {
            ...baseBarOptions.scales,
            y: {
                ...baseBarOptions.scales.y,
                title: { display: true, text: 'Kcal' },
                suggestedMax: values[1] * 1.1
            }
        }
    };

    return (
        <div className="chart-wrapper">
            <span>Kalorier</span>
            <div className="chart-inner">
                <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default CaloriesChart;
